import { DASHBOARD_RESOURCES, DASHBOARD_SCOPES, PAGE_NAMES } from 'constant';
import listSegment from 'assets/dashboard/listSegment.png';
import tdsIcon from 'assets/dashboard/tds.png';
import gstIcon from 'assets/dashboard/gstIcon.webp';
import downtimeManagementIcon from 'assets/dashboard/scheduledDowntime.png';
import dynamicSwitcherIcon from 'assets/dashboard/dynamicSwitcher.png';
import paymentPgFailureIcon from 'assets/dashboard/paymentFailure.png';
import CtdDashboardHome from './ctd';
import TdsDashboardHome from './tds';
import GstDashboardHome from './gst';
import PaymentPGFailureDashboard from './paymentPGFailure';
import TdsAbsorptionDashboardHome from './tdsAbsorption';
import DowntimeManagementDashboard from './downtimemanagement';
import DynamicSwitcherDashboardHome from './dynamicSwitcher';

export const FINANCE_RESOURCES = {
	ctd: 'ctd',
	gst: 'gst',
	tds: 'tds',
	tdsAbsorption: 'tdsAbsorption',
	downtimeManagement: 'downtimeManagement',
	dynamicSwitcher: 'dynamicSwitcher',
	paymentPgFailure: 'paymentPgFailure'
};
export const URL = {
	[FINANCE_RESOURCES.ctd]: `/${PAGE_NAMES.dashboard}/${DASHBOARD_RESOURCES.finance}/${FINANCE_RESOURCES.ctd}`,
	[FINANCE_RESOURCES.tds]: `/${PAGE_NAMES.dashboard}/${DASHBOARD_RESOURCES.finance}/${FINANCE_RESOURCES.tds}`,
	[FINANCE_RESOURCES.gst]: `/${PAGE_NAMES.dashboard}/${DASHBOARD_RESOURCES.finance}/${FINANCE_RESOURCES.gst}`,
	[FINANCE_RESOURCES.tdsAbsorption]: `/${PAGE_NAMES.dashboard}/${DASHBOARD_RESOURCES.finance}/${FINANCE_RESOURCES.tdsAbsorption}`,
	[FINANCE_RESOURCES.downtimeManagement]: `/${PAGE_NAMES.dashboard}/${DASHBOARD_RESOURCES.finance}/${FINANCE_RESOURCES.downtimeManagement}`,
	[FINANCE_RESOURCES.dynamicSwitcher]: `/${PAGE_NAMES.dashboard}/${DASHBOARD_RESOURCES.finance}/${FINANCE_RESOURCES.dynamicSwitcher}`,
	[FINANCE_RESOURCES.paymentPgFailure]: `/${PAGE_NAMES.dashboard}/${DASHBOARD_RESOURCES.finance}/${FINANCE_RESOURCES.paymentPgFailure}`,
	[FINANCE_RESOURCES.tdsAbsorption]: `/${PAGE_NAMES.dashboard}/${DASHBOARD_RESOURCES.finance}/${FINANCE_RESOURCES.tdsAbsorption}`
};

export const LABEL = {
	[FINANCE_RESOURCES.ctd]: 'CTD',
	[FINANCE_RESOURCES.gst]: 'GST',
	[FINANCE_RESOURCES.tdsAbsorption]: 'TDS Absorption',
	[FINANCE_RESOURCES.downtimeManagement]: 'Downtime Management',
	[FINANCE_RESOURCES.dynamicSwitcher]: 'Dynamic Switcher',
	[FINANCE_RESOURCES.paymentPgFailure]: 'Payment PG Failure',
	[FINANCE_RESOURCES.tds]: 'TDS Refund Rewards',
	[FINANCE_RESOURCES.tdsAbsorption]: 'TDS Absorption'
};

export const COMPONENT = {
	[FINANCE_RESOURCES.ctd]: CtdDashboardHome,
	[FINANCE_RESOURCES.tds]: TdsDashboardHome,
	[FINANCE_RESOURCES.gst]: GstDashboardHome,
	[FINANCE_RESOURCES.tdsAbsorption]: TdsAbsorptionDashboardHome,
	[FINANCE_RESOURCES.downtimeManagement]: DowntimeManagementDashboard,
	[FINANCE_RESOURCES.dynamicSwitcher]: DynamicSwitcherDashboardHome,
	[FINANCE_RESOURCES.paymentPgFailure]: PaymentPGFailureDashboard,
	[FINANCE_RESOURCES.tdsAbsorption]: TdsAbsorptionDashboardHome
};

export const GET_ACTION = {
	[FINANCE_RESOURCES.ctd]: DASHBOARD_SCOPES[DASHBOARD_RESOURCES.finance].getCTDActiveOffers
};

export const IMAGE_SOURCE = {
	[FINANCE_RESOURCES.ctd]: listSegment,
	[FINANCE_RESOURCES.tds]: tdsIcon,
	[FINANCE_RESOURCES.gst]: gstIcon,
	[FINANCE_RESOURCES.tdsAbsorption]: tdsIcon,
	[FINANCE_RESOURCES.downtimeManagement]: downtimeManagementIcon,
	[FINANCE_RESOURCES.dynamicSwitcher]: dynamicSwitcherIcon,
	[FINANCE_RESOURCES.paymentPgFailure]: paymentPgFailureIcon,
	[FINANCE_RESOURCES.tdsAbsorption]: tdsIcon
};

export type Record = {
	[key: string]: string | number | boolean;
};

export type SelectedUserType = {
	email: string;
	uid: string;
	phone: string;
	userSegment: string;
	addToStatic: boolean;
};
